<script lang="ts">
    import { onDestroy, onMount } from 'svelte'

    export let size = 250
    let video
    let video_container
    async function startCam() {
        const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true })
        video.srcObject = mediaStream
        video.play()
    }

    onMount(async () => {
        await startCam()
        if (window.innerWidth > 1920) {
            window.alert(
                'IMPORTANTE: sua resolução é muito alta e não entregará uma boa experiência.\nEscolha uma resolução menor ou troque de monitor.\n\nDICA: Aperte F11 e grave em tela cheia.',
            )
        } else {
            window.alert('DICA: Aperte F11 e grave em tela cheia.')
        }
    })

    onDestroy(() => {
        try {
            video.srcObject.getTracks().forEach((track) => track.stop())
        } catch (error) {}
    })

    function windowMouseMove(ev) {
        if (ev.x >= window.innerWidth - 275 && ev.y >= window.innerHeight - 275) {
            video_container.style.top = '25px'
        }
        if (ev.x < window.innerWidth / 1.7 || ev.y < window.innerHeight / 1.7) {
            video_container.style.top = 'calc(100% - 275px)'
        }
    }
</script>

<svelte:window on:mousemove={windowMouseMove} />
<div class="video_container" bind:this={video_container} style="width:{size}px;height:{size}px;">
    <video id="video" bind:this={video}></video>
</div>

<style>
    .video_container {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        overflow: hidden;
        position: fixed;
        z-index: 99999999;
        top: calc(100% - 275px);
        right: 25px;
        transition: top 700ms ease 0s;
        box-shadow: 5px 5px 20px #000000aa;
    }

    .video_container video {
        height: 100%;
    }
</style>
